import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import i18n from "i18next";

export const BRIDGE_NUMBERS_LOADING = "BRIDGE_NUMBERS_LOADING"
export const BRIDGE_NUMBERS_SUCCESS = "BRIDGE_NUMBERS_SUCCESS";
export const BRIDGE_NUMBERS_FAILED = "BRIDGE_NUMBERS_FAILED";

export const CALL_RECORDINGS_LOADING = "CALL_RECORDINGS_LOADING"
export const CALL_RECORDINGS_SUCCESS = "CALL_RECORDINGS_SUCCESS";
export const CALL_RECORDINGS_FAILED = "CALL_RECORDINGS_FAILED";
export const CALL_RECORDINGS_RESET = "CALL_RECORDINGS_RESET";

export const REPORT_FIELDS_LOADING = "REPORT_FIELDS_LOADING";
export const REPORT_FIELDS_SUCCESS = "REPORT_FIELDS_SUCCESS";
export const REPORT_FIELDS_FAILED  = "REPORT_FIELDS_FAILED";

export const ACTIVE_BRIDGE_NUMBERS_LOADING = "ACTIVE_BRIDGE_NUMBERS_LOADING"
export const ACTIVE_BRIDGE_NUMBERS_SUCCESS = "ACTIVE_BRIDGE_NUMBERS_SUCCESS";
export const ACTIVE_BRIDGE_NUMBERS_FAILED = "ACTIVE_BRIDGE_NUMBERS_FAILED";

export const SPEECH_REPORT_FIELDS_LOADING = "SPEECH_REPORT_FIELDS_LOADING";
export const SPEECH_REPORT_FIELDS_SUCCESS = "SPEECH_REPORT_FIELDS_SUCCESS";
export const SPEECH_REPORT_FIELDS_FAILED  = "SPEECH_REPORT_FIELDS_FAILED";


export const getBridgeNumbers = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: BRIDGE_NUMBERS_LOADING });

        let endpoint = `/bridge-numbers`

        networkCall("get", `${endpoint}`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.data) {
                    dispatch({ type: BRIDGE_NUMBERS_SUCCESS, payload: { res: res.data.bridge_numbers } });
                } else {
                    dispatch({ type: BRIDGE_NUMBERS_FAILED, payload: { error: res.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: BRIDGE_NUMBERS_FAILED, payload: { error } });
                }
            });
    }
}

export const getActiveBridgeNumbers = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: ACTIVE_BRIDGE_NUMBERS_LOADING });

        let endpoint = `/active-bridge-numbers`

        networkCall("get", `${endpoint}`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.data) {
                    dispatch({ type: ACTIVE_BRIDGE_NUMBERS_SUCCESS, payload: { res: res.data.bridge_numbers } });
                } else {
                    dispatch({ type: ACTIVE_BRIDGE_NUMBERS_FAILED, payload: { error: res.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: ACTIVE_BRIDGE_NUMBERS_FAILED, payload: { error } });
                }
            });
    }
}

export const getRecordings = (data: string, is_speech=false) => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CALL_RECORDINGS_LOADING });

        let endpoint;
        if (is_speech) {
            endpoint = `/get-recordings?recording_id=${data}`
        } else {
            endpoint = `/get-recordings?call_id=${data}&for_download=true`
        }

        networkCall("get", `${endpoint}`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.data) {
                    dispatch({ type: CALL_RECORDINGS_SUCCESS, payload: { res: res.data } });
                } else {
                    dispatch({ type: CALL_RECORDINGS_FAILED, payload: { error: res.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: CALL_RECORDINGS_FAILED, payload: error?.response?.error?.scalar });
                }
            });
    }
}

export const getExportSideBarMultiSelectOptions = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: REPORT_FIELDS_LOADING });

        let endpoint = `/report-fields`

        networkCall("get", `${endpoint}`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                 if (res?.data) {
                    dispatch({ type: REPORT_FIELDS_SUCCESS, payload: { res: res.data } });
                } else {
                    dispatch({ type: REPORT_FIELDS_FAILED, payload: { error: res.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: REPORT_FIELDS_FAILED, payload: { error } });
                }
            });
    }
}
export const getSpeechExportSideBarMultiSelectOptions = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: SPEECH_REPORT_FIELDS_LOADING });

        let endpoint = `/speech-report-fields` // TODO change it

        networkCall("get", `${endpoint}`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res?.data) {
                    dispatch({ type: SPEECH_REPORT_FIELDS_SUCCESS, payload: { res: res.data } });
                } else {
                    dispatch({ type: SPEECH_REPORT_FIELDS_FAILED, payload: { error: res.error } });
                }
            }).catch((error) => {
            if (error?.response?.data) {
                dispatch({ type: SPEECH_REPORT_FIELDS_FAILED, payload: { error } });
            }
        });
    }
}

export const getReportDownloadUrl = (id:number, cb: (data:string, status: boolean)=>void) => {
    networkCall("get", `/report-download?id=${id}`, apiBaseUrl.baseUrl)
    .then((res:any)=>{
        if(res.data.s3_info.length){
            cb(res.data.s3_info, true);
        }else{
            cb(i18n.t("unabletoDownload"), false);
        }
    }).catch(()=>{
        cb(i18n.t("unabletoDownload"), false);
    });
} 